import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_theme90wn9glxu60a as get_theme,
  viewPath22j8rl3x6zdx1 as viewPath,
} from './Element.ext.mjs';
import {
  Companion_getInstanceoo2y82hqzamu as Companion_getInstance,
  None_instance1vdtnxdfytk8h as None_instance,
  WorkingSemantic_getInstance1c0k8igfs4qnm as WorkingSemantic_getInstance,
  LoadingSemantic_getInstance2uz34omnpc1bs as LoadingSemantic_getInstance,
} from '../models/Theme.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ReactiveStatel8ixobo86msn as ReactiveState,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance_0,
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Metadata2mqfolh2et60e as Metadata } from '../exceptions/handling.mjs';
import {
  handleException14reyfdad0gfg as handleException,
  get_ssrDispatcher1kagzmco8c1l4 as get_ssrDispatcher,
} from './ElementContext.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import {
  Never_getInstance1g83fzxrvq57k as Never_getInstance,
  addAndRunListener8g331b1wn43q as addAndRunListener,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  Entry3ibt1cjje8fz9 as Entry,
  OrderedKeyedListh74dkke7tuy6 as OrderedKeyedList,
} from '../utils/OrderedKeyedList.mjs';
import { AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance27cl4xxdoduaj as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineExceptionHandler.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  report1vfr9zf0i9d9p as report,
  get_debugMode2ku08uo1anfv as get_debugMode,
  Default_getInstance27jodt8hd1bac as Default_getInstance,
  checkLeakAfterDelayr9e6vxihbhwn as checkLeakAfterDelay,
} from '../debugger.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  Element2gr7ezmxqaln7 as Element,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import {
  get_keyp54t1phutrkg as get_key,
  StatusListener1jkchgp0onou6 as StatusListener,
  onRemove3k528udkni1ni as onRemove,
} from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  Debugger_getInstancengm4b9abzu1y as Debugger_getInstance,
  get_driverValue2l8j2029z0kp4 as get_driverValue,
  get_driverActionsql9tpg6sskd4 as get_driverActions,
  driverDisplay2w9hnlh9xpqdc as driverDisplay,
  Element1y2xoj9fs2s4 as Element_0,
} from './Element.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { TelemetryContext3p4gcznz77gxw as TelemetryContext } from '../telemetry/TelemetryContext.mjs';
import { coroutineContextOf2kr7rpdapvlde as coroutineContextOf } from './MutableCoroutineContext.mjs';
import { LiveRegionMode_None_getInstance2rbbbabo907qu as LiveRegionMode_None_getInstance } from '../models/LiveRegionMode.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Companion_getInstance252uiobns9yoh as Companion_getInstance_1 } from '../models/Rect.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString_1,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { removePrefix279df90bhrqqg as removePrefix } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  identityHashCodemue8eqr5m304 as identityHashCode,
  WeakReferencel11chldcck68 as WeakReference,
} from '../debugger.js.mjs';
import { toString1h6jjoch8cjt8 as toString_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { invoke3srivg5vay2ub as invoke } from './KiteUiCoroutineScopeHelpers.mjs';
import {
  invoke3ik0mg5nfxrhr as invoke_0,
  bind1v20po654iwh5 as bind,
  debounce3va8k9t2b2qkc as debounce,
  debounce2ek3q4aktnyhg as debounce_0,
} from '../../../../../reactive/com/lightningkite/reactive/context/CoroutineScopeHelpers.mjs';
import { NativeElement2p8z5z0r9meck as NativeElement } from './NativeElement.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ensureOutermostElement(_this__u8e3s4) {
  _this__u8e3s4.get_underlyingNativeElement_vngz33_k$().set_outermostElement_j4i68j_k$(_this__u8e3s4);
}
var sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0Class;
function sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0() {
  if (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      get_31089n_k$(element) {
        return this.function_1(element);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, GetBaseTheme()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0', VOID, VOID, [GetBaseTheme(), FunctionAdapter()]);
    sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0Class = $;
  }
  return sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0Class;
}
var sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0Class_0;
function sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0_0() {
  if (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      get_31089n_k$(element) {
        return this.function_1(element);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, GetBaseTheme()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0', VOID, VOID, [GetBaseTheme(), FunctionAdapter()]);
    sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0Class_0 = $;
  }
  return sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0Class_0;
}
function NativeElementCommonCode$GetBaseTheme$Companion$fromParent$lambda(element) {
  var tmp0_safe_receiver = element.get_parent_hy4reb_k$();
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_theme(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_elvis_lhs = tmp1_safe_receiver.revert_1;
    tmp = tmp0_elvis_lhs == null ? tmp1_safe_receiver : tmp0_elvis_lhs;
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? Companion_getInstance().placeholder_1 : tmp2_elvis_lhs;
}
function NativeElementCommonCode$GetBaseTheme$Companion$fromParentNonCascading$lambda(element) {
  var tmp0_safe_receiver = element.get_parent_hy4reb_k$();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_theme(tmp0_safe_receiver);
  return tmp1_elvis_lhs == null ? Companion_getInstance().placeholder_1 : tmp1_elvis_lhs;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = NativeElementCommonCode$GetBaseTheme$Companion$fromParent$lambda;
        tmp.fromParent_1 = new (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0())(tmp_0);
        var tmp_1 = this;
        var tmp_2 = NativeElementCommonCode$GetBaseTheme$Companion$fromParentNonCascading$lambda;
        tmp_1.fromParentNonCascading_1 = new (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_GetBaseTheme$0_0())(tmp_2);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_2() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function _set_state__ks53v8($this, value) {
  if (!equals(new (ReactiveState())($this.state_1), new (ReactiveState())(value))) {
    $this.state_1 = value;
    $this.invokeAllListeners_uusj2y_k$();
    $this.$this_1.refreshTheming_1agefv_k$();
  }
}
function recalculateState($this) {
  if (!$this.$this_1.currentlyActive_eqs9ec_k$())
    return Unit_instance;
  var tmp;
  if ($this.exceptionCount_1 > 0) {
    var tmp0 = $this.processes_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.exception' call
        var this_0 = element.get_state_wc71uu_k$();
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp0_safe_receiver = tmp_0 instanceof InternalReactiveThrownException() ? tmp_0 : null;
        var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.exception_1;
        var tmp_1;
        if (tmp0_safe_receiver_0 == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = to(element, tmp0_safe_receiver_0);
        }
        var result = tmp_1;
        if (!(result == null)) {
          tmp$ret$0 = result;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var pair = tmp$ret$0;
    if (pair == null) {
      $this.exceptionCount_1 = 0;
      return recalculateState($this);
    }
    var process = pair.component1_7eebsc_k$();
    var exception = pair.component2_7eebsb_k$();
    var tmp0_safe_receiver_1 = $this.releaseExceptionHandler_1;
    if (tmp0_safe_receiver_1 == null)
      null;
    else
      tmp0_safe_receiver_1();
    $this.releaseExceptionHandler_1 = handleException($this.$this_1.get_context_h02k06_k$(), exception, new (Metadata())($this.$this_1.get_outermostElement_wqahza_k$(), process, $this.foreground_1));
    tmp = Companion_getInstance_0().exception_iibuh2_k$(exception);
  } else if ($this.notReadyCount_1 > 0) {
    var tmp1_safe_receiver = $this.releaseExceptionHandler_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver();
    $this.releaseExceptionHandler_1 = null;
    tmp = Companion_getInstance_0().notReady_1;
  } else {
    var tmp2_safe_receiver = $this.releaseExceptionHandler_1;
    if (tmp2_safe_receiver == null)
      null;
    else
      tmp2_safe_receiver();
    $this.releaseExceptionHandler_1 = null;
    tmp = _ReactiveState___init__impl__fvdp9b(Unit_instance);
  }
  _set_state__ks53v8($this, tmp);
}
function _Step___init__impl__1kywol(order) {
  return order;
}
function _Step___get_order__impl__ouy2c($this) {
  return $this;
}
function Step__compareTo_impl_3dbd5l($this, other) {
  return compareTo(_Step___get_order__impl__ouy2c($this), _Step___get_order__impl__ouy2c(other));
}
function Step__compareTo_impl_3dbd5l_0($this, other) {
  return Step__compareTo_impl_3dbd5l($this.order_1, other instanceof Step() ? other.order_1 : THROW_CCE());
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.elementStyling_1 = _Step___init__impl__1kywol(0.0);
        this.themeChoice_1 = _Step___init__impl__1kywol(0.2);
        this.dynamicChoice_1 = _Step___init__impl__1kywol(0.4);
        this.elementStatus_1 = _Step___init__impl__1kywol(0.6);
        this.processingStatus_1 = _Step___init__impl__1kywol(0.8);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_3() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
function Step__toString_impl_9qe163($this) {
  return 'Step(order=' + $this + ')';
}
function Step__hashCode_impl_vhjxyy($this) {
  return getNumberHashCode($this);
}
function Step__equals_impl_f3fjku($this, other) {
  if (!(other instanceof Step()))
    return false;
  var tmp0_other_with_cast = other.order_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class;
function sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0() {
  if (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      get_31089n_k$(element) {
        return this.function_1(element);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, ThemeForElement()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0', VOID, VOID, [ThemeForElement(), FunctionAdapter()]);
    sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class = $;
  }
  return sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class;
}
function NativeElementCommonCode$ThemePipeline$ThemeForElement$Companion$processingTheming$lambda(element) {
  var element_0 = element.get_underlyingNativeElement_vngz33_k$();
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var this_0 = element_0.get_foregroundProcesses_2lrnkf_k$().get_state_wc71uu_k$();
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = WorkingSemantic_getInstance();
  } else {
    if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
      tmp = WorkingSemantic_getInstance();
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
        tmp = WorkingSemantic_getInstance();
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
          tmp = None_instance;
        } else {
          _ReactiveState___get_raw__impl__92ipya(this_0);
          tmp = None_instance;
        }
      }
    }
  }
  var t = tmp;
  var tmp_0;
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.success' call
  var this_1 = element_0.get_backgroundProcesses_v8cmfu_k$().get_state_wc71uu_k$();
  var tmp_1;
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
  var tmp_2;
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
  if (!equals(_ReactiveState___get_raw__impl__92ipya(this_1), InternalReactiveNotActive_instance)) {
    tmp_2 = !equals(_ReactiveState___get_raw__impl__92ipya(this_1), InternalReactiveNotReady_instance);
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    var tmp_3 = _ReactiveState___get_raw__impl__92ipya(this_1);
    tmp_1 = !(tmp_3 instanceof InternalReactiveThrownException());
  } else {
    tmp_1 = false;
  }
  if (!tmp_1) {
    tmp_0 = t.plus_duvq05_k$(LoadingSemantic_getInstance());
  } else {
    tmp_0 = t;
  }
  return tmp_0;
}
var ConstantClass;
function Constant() {
  if (ConstantClass === VOID) {
    class $ {
      constructor(theme) {
        this.theme_1 = theme;
      }
      get_31089n_k$(element) {
        return this.theme_1;
      }
      toString() {
        return 'Constant(theme=' + toString(this.theme_1) + ')';
      }
      hashCode() {
        return hashCode(this.theme_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Constant()))
          return false;
        if (!equals(this.theme_1, other.theme_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Constant', VOID, VOID, [ThemeForElement()]);
    ConstantClass = $;
  }
  return ConstantClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = NativeElementCommonCode$ThemePipeline$ThemeForElement$Companion$processingTheming$lambda;
        tmp.processingTheming_1 = new (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0())(tmp_0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var StepClass;
function Step() {
  if (StepClass === VOID) {
    class $ {
      constructor(order) {
        Companion_getInstance_3();
        this.order_1 = order;
      }
      compareTo_of8afs_k$(other) {
        return Step__compareTo_impl_3dbd5l(this.order_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return Step__compareTo_impl_3dbd5l_0(this, other);
      }
      toString() {
        return Step__toString_impl_9qe163(this.order_1);
      }
      hashCode() {
        return Step__hashCode_impl_vhjxyy(this.order_1);
      }
      equals(other) {
        return Step__equals_impl_f3fjku(this.order_1, other);
      }
    }
    initMetadataForClass($, 'Step', VOID, VOID, [Comparable()]);
    StepClass = $;
  }
  return StepClass;
}
var ThemeForElementClass;
function ThemeForElement() {
  if (ThemeForElementClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ThemeForElement');
    ThemeForElementClass = $;
  }
  return ThemeForElementClass;
}
function foldOn($this, $receiver, element) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = null;
  var _iterator__ex2g4s = $receiver.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s.next_20eer_k$();
    var acc = accumulator;
    var op = element_0.component2_7eebsb_k$();
    accumulator = acc == null ? op.get_31089n_k$(element) : acc.plus_duvq05_k$(op.get_31089n_k$(element));
  }
  var tmp0_elvis_lhs = accumulator;
  return tmp0_elvis_lhs == null ? None_instance : tmp0_elvis_lhs;
}
var GetBaseThemeClass;
function GetBaseTheme() {
  if (GetBaseThemeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'GetBaseTheme');
    GetBaseThemeClass = $;
  }
  return GetBaseThemeClass;
}
var ProcessesClass;
function Processes() {
  if (ProcessesClass === VOID) {
    class $ extends BaseListenable() {
      constructor($outer, foreground) {
        return new.target.new_com_lightningkite_kiteui_views_NativeElementCommonCode_Processes_hgc2eq_k$($outer, foreground);
      }
      static new_com_lightningkite_kiteui_views_NativeElementCommonCode_Processes_hgc2eq_k$($outer, foreground, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$($box);
        $this.foreground_1 = foreground;
        $this.processes_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
        $this.exceptionCount_1 = 0;
        $this.notReadyCount_1 = 0;
        $this.releaseExceptionHandler_1 = null;
        $this.state_1 = _ReactiveState___init__impl__fvdp9b(Unit_instance);
        return $this;
      }
      get_state_l6ty6g_k$() {
        return this.state_1;
      }
      get_state_wc71uu_k$() {
        return this.get_state_l6ty6g_k$();
      }
      watch_lu5yhm_k$(status) {
        if (!this.processes_1.add_utx5q5_k$(status))
          return Never_getInstance().NOOP_RELEASE_1;
        var prevSeverity = {_v: -1};
        var release = addAndRunListener(status, () => {
          // Inline function 'com.lightningkite.kiteui.onMainThread' call
          // Inline function 'com.lightningkite.kiteui.views.Processes.severity' call
          var this_0 = status.get_state_wc71uu_k$();
          var tmp;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.exception' call
          var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
          var tmp0_safe_receiver = tmp_0 instanceof InternalReactiveThrownException() ? tmp_0 : null;
          if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.exception_1) == null)) {
            tmp = 2;
          } else {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_1;
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
            if (!equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotActive_instance)) {
              tmp_1 = !equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotReady_instance);
            } else {
              tmp_1 = false;
            }
            if (!tmp_1) {
              tmp = 1;
            } else {
              tmp = 0;
            }
          }
          var s = tmp;
          if (!(prevSeverity._v === s)) {
            var tmp0_subject = prevSeverity._v;
            if (tmp0_subject === 2) {
              this.exceptionCount_1 = this.exceptionCount_1 - 1 | 0;
            } else if (tmp0_subject === 1) {
              this.notReadyCount_1 = this.notReadyCount_1 - 1 | 0;
            }
            if (s === 2) {
              this.exceptionCount_1 = this.exceptionCount_1 + 1 | 0;
            } else if (s === 1) {
              this.notReadyCount_1 = this.notReadyCount_1 + 1 | 0;
            }
            prevSeverity._v = s;
            recalculateState(this);
          } else if (s === 2) {
            recalculateState(this);
          }
          return Unit_instance;
        });
        return () => {
          release();
          var tmp;
          if (this.processes_1.remove_cedx0m_k$(status)) {
            var tmp0_subject = prevSeverity._v;
            var tmp_0;
            if (tmp0_subject === 2) {
              this.exceptionCount_1 = this.exceptionCount_1 - 1 | 0;
              recalculateState(this);
              tmp_0 = Unit_instance;
            } else if (tmp0_subject === 1) {
              this.notReadyCount_1 = this.notReadyCount_1 - 1 | 0;
              recalculateState(this);
              tmp_0 = Unit_instance;
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($, 'Processes', VOID, VOID, [Reactive()]);
    ProcessesClass = $;
  }
  return ProcessesClass;
}
var ThemePipelineClass;
function ThemePipeline() {
  if (ThemePipelineClass === VOID) {
    class $ {
      constructor(operations) {
        return new.target.new_com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_6g3sim_k$(operations);
      }
      static new_com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_6g3sim_k$(operations) {
        var $this = createThis(this);
        $this.operations_1 = operations;
        return $this;
      }
      static new_com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ntyr4b_k$(init) {
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var inductionVariable = 0;
        var last = init.length;
        while (inductionVariable < last) {
          var item = init[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$1 = new (Entry())(item.first_1, item.second_1);
          destination.add_utx5q5_k$(tmp$ret$1);
        }
        return this.new_com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_6g3sim_k$(OrderedKeyedList().new_com_lightningkite_kiteui_utils_OrderedKeyedList_pzp04i_k$(destination));
      }
      get_b304b5_k$(step, element) {
        return foldOn(this, this.operations_1.get_mqs22f_k$(new (Step())(step)), element);
      }
      apply_k7mlwn_k$(element, theme) {
        // Inline function 'kotlin.collections.fold' call
        var accumulator = null;
        var _iterator__ex2g4s = this.operations_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s.next_20eer_k$();
          var acc = accumulator;
          var op = element_0.component2_7eebsb_k$();
          accumulator = acc == null ? op.get_31089n_k$(element).invoke_h6mny6_k$(theme) : acc.plus_duvq05_k$(op.get_31089n_k$(element));
        }
        var tmp0_elvis_lhs = accumulator;
        return tmp0_elvis_lhs == null ? theme.withoutBack_1 : tmp0_elvis_lhs;
      }
      add_n6yx8s_k$(step, op) {
        return this.operations_1.add_s9j6db_k$(new (Step())(step), op);
      }
      add_6yb5u0_k$(step, theme) {
        return this.operations_1.add_s9j6db_k$(new (Step())(step), new (Constant())(theme));
      }
      set_tnq7ny_k$(step, theme) {
        if (theme == null)
          this.operations_1.remove_v7qput_k$(new (Step())(step));
        else {
          this.operations_1.set_y4lt5s_k$(new (Step())(step), new (Constant())(theme));
        }
      }
    }
    initMetadataForClass($, 'ThemePipeline');
    ThemePipelineClass = $;
  }
  return ThemePipelineClass;
}
var NativeElementCommonCode$coroutineContext$$inlined$CoroutineExceptionHandler$1Class;
function NativeElementCommonCode$coroutineContext$$inlined$CoroutineExceptionHandler$1() {
  if (NativeElementCommonCode$coroutineContext$$inlined$CoroutineExceptionHandler$1Class === VOID) {
    class $ extends AbstractCoroutineContextElement() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        super(Key_instance, $box);
      }
      handleException_e679jj_k$(context, exception) {
        var tmp$ret$0;
        $l$block: {
          if (exception instanceof CancellationException()) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          report(exception, this.this$0__1.toString());
          if (exception instanceof Exception()) {
            handleException(this.this$0__1.get_context_h02k06_k$(), exception, new (Metadata())(this.this$0__1.get_outermostElement_wqahza_k$(), null, null, mapOf(to('ctx', toString(context)))));
          }
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Element()]);
    NativeElementCommonCode$coroutineContext$$inlined$CoroutineExceptionHandler$1Class = $;
  }
  return NativeElementCommonCode$coroutineContext$$inlined$CoroutineExceptionHandler$1Class;
}
var NativeElementCommonCode$coroutineContext$1Class;
function NativeElementCommonCode$coroutineContext$1() {
  if (NativeElementCommonCode$coroutineContext$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
      }
      watchBackgroundProcess_1utgjt_k$(status) {
        return this.this$0__1.watchBackgroundProcess_1utgjt_k$(status);
      }
      watchForegroundProcess_2u2sac_k$(status) {
        return this.this$0__1.watchForegroundProcess_2u2sac_k$(status);
      }
    }
    protoOf($).get_key_18j28a_k$ = get_key;
    protoOf($).get_y2st91_k$ = get;
    protoOf($).fold_j2vaxd_k$ = fold;
    protoOf($).minusKey_9i5ggf_k$ = minusKey;
    protoOf($).plus_s13ygv_k$ = plus;
    initMetadataForClass($, VOID, VOID, VOID, [StatusListener()]);
    NativeElementCommonCode$coroutineContext$1Class = $;
  }
  return NativeElementCommonCode$coroutineContext$1Class;
}
var NativeElementCommonCodeClass;
function NativeElementCommonCode() {
  if (NativeElementCommonCodeClass === VOID) {
    class $ {
      constructor(context) {
        this.context_1 = context;
        this.outermostElement_1 = this;
        this.parent_1 = null;
        if (Debugger_getInstance().countInstances_1) {
          Debugger_getInstance().recordCreated_ej7mju_k$(this);
        }
        this.job_1 = SupervisorJob();
        var tmp = this;
        // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
        var tmp_0 = new (NativeElementCommonCode$coroutineContext$$inlined$CoroutineExceptionHandler$1())(this);
        var tmp0_elvis_lhs = get_ssrDispatcher(this.get_context_h02k06_k$());
        var tmp_1 = tmp0_elvis_lhs == null ? Dispatchers_getInstance().get_Main_wo5vz6_k$().get_immediate_r3y8eg_k$() : tmp0_elvis_lhs;
        tmp.coroutineContext_1 = coroutineContextOf([this.job_1, tmp_0, tmp_1, new (NativeElementCommonCode$coroutineContext$1())(this), new (TelemetryContext())(VOID, VOID, asNativeElementOrFail(this))]);
        this.fullyStarted_1 = false;
        this.isShutdown_1 = false;
        this.themeAndBack_1 = Companion_getInstance().placeholder_1.withBack_1;
        this.paddingByEdge_1 = null;
        this.safeAreaPadding_1 = null;
        this.themeBase_1 = Companion_getInstance_2().fromParent_1;
        this.themePipeline_1 = ThemePipeline().new_com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ntyr4b_k$([to(new (Step())(Companion_getInstance_3().processingStatus_1), Companion_getInstance_4().processingTheming_1)]);
        this.internalBackgroundProcesses_1 = Processes().new_com_lightningkite_kiteui_views_NativeElementCommonCode_Processes_hgc2eq_k$(this, false);
        this.internalForegroundProcesses_1 = Processes().new_com_lightningkite_kiteui_views_NativeElementCommonCode_Processes_hgc2eq_k$(this, true);
        this.accessibleLabel_1 = null;
        this.accessibleLiveRegion_1 = LiveRegionMode_None_getInstance();
        this.labelFor_1 = null;
        this.describedBy_1 = null;
        this.debugName_1 = null;
      }
      get_context_h02k06_k$() {
        return this.context_1;
      }
      get_underlyingNativeElement_vngz33_k$() {
        return asNativeElementOrFail(this);
      }
      set_outermostElement_j4i68j_k$(_set____db54di) {
        this.outermostElement_1 = _set____db54di;
      }
      get_outermostElement_wqahza_k$() {
        return this.outermostElement_1;
      }
      set_parent_pjy9os_k$(value) {
        // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
        var tmp;
        if (!true && get_debugMode()) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = Debugger_getInstance().debugTarget_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_underlyingNativeElement_vngz33_k$()) === this;
        }
        if (tmp) {
          var tmp_0 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
          var tmp$ret$1 = 'setting parent to ' + toString_0(value);
          tmp_0.info_59mt0k_k$([tmp$ret$1]);
        }
        this.parent_1 = value;
        if (!(value == null)) {
          this.refreshTheming_1agefv_k$();
        }
      }
      get_parent_hy4reb_k$() {
        return this.parent_1;
      }
      get_coroutineContext_115oqo_k$() {
        return this.coroutineContext_1;
      }
      onStartup_vrxh3i_k$() {
        if (this.fullyStarted_1)
          return Unit_instance;
        this.fullyStarted_1 = true;
        // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
        var tmp;
        if (!true && get_debugMode()) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = Debugger_getInstance().debugTarget_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_underlyingNativeElement_vngz33_k$()) === this;
        }
        if (tmp) {
          var tmp_0 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
          var tmp$ret$1 = 'starting...';
          tmp_0.info_59mt0k_k$([tmp$ret$1]);
        }
        this.refreshTheming_1agefv_k$();
        // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
        var tmp_1;
        if (!true && get_debugMode()) {
          tmp_1 = true;
        } else {
          var tmp0_safe_receiver_0 = Debugger_getInstance().debugTarget_1;
          tmp_1 = (tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.get_underlyingNativeElement_vngz33_k$()) === this;
        }
        if (tmp_1) {
          var tmp_2 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
          var tmp$ret$3 = 'new theme: ' + get_theme(this).id_1;
          tmp_2.info_59mt0k_k$([tmp$ret$3]);
        }
      }
      onShutdown_5jzxq3_k$() {
        if (this.isShutdown_1)
          return Unit_instance;
        this.job_1.cancel$default_8haxne_k$();
        this.isShutdown_1 = true;
        if (Debugger_getInstance().countInstances_1) {
          Debugger_getInstance().recordShutdown_cnq552_k$(this);
        }
        if (Debugger_getInstance().leakDetect_1) {
          this.leakDetect_rzp4wm_k$();
        }
        this.set_parent_pjy9os_k$(null);
        this.set_labelFor_go6ca6_k$(null);
        this.set_describedBy_4bf3cf_k$(null);
      }
      set_themeAndBack_a1wxbo_k$(value) {
        if (value.equals(this.themeAndBack_1))
          return Unit_instance;
        var previous = this.themeAndBack_1;
        this.themeAndBack_1 = value;
        this.nativeApplyTheme_6heplg_k$(value);
        this.refreshPadding_un7dm_k$();
        this.themeAndBackChanged_kx7s5p_k$(previous, value);
      }
      get_themeAndBack_k3yag2_k$() {
        return this.themeAndBack_1;
      }
      themeAndBackChanged_kx7s5p_k$(previous, current) {
      }
      set_paddingByEdge_53g79y_k$(value) {
        this.paddingByEdge_1 = value;
        // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
        var tmp;
        if (!true && get_debugMode()) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = Debugger_getInstance().debugTarget_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_underlyingNativeElement_vngz33_k$()) === this;
        }
        if (tmp) {
          var tmp_0 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
          var tmp$ret$1 = 'Setting padding to ' + toString_0(value);
          tmp_0.info_59mt0k_k$([tmp$ret$1]);
        }
        this.refreshPadding_un7dm_k$();
      }
      get_paddingByEdge_29dw58_k$() {
        return this.paddingByEdge_1;
      }
      set_safeAreaPadding_bpzgd4_k$(value) {
        this.safeAreaPadding_1 = value;
        this.refreshPadding_un7dm_k$();
      }
      get_appliedPadding_3m7h7h_k$() {
        if (!this.fullyStarted_1 && get_debugMode()) {
          Default_getInstance().warn_e3mr9o_k$([this.toString() + ' attempted to calculate applied padding before fully started.']);
        }
        var tmp0_elvis_lhs = this.paddingByEdge_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.takeIf' call
          var this_0 = get_theme(this).padding_1;
          var tmp_0;
          if (this.themeAndBack_1.padding_1) {
            tmp_0 = this_0;
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp1_elvis_lhs = tmp;
        // Inline function 'kotlin.let' call
        var p = tmp1_elvis_lhs == null ? Companion_getInstance_1().ZERO_1 : tmp1_elvis_lhs;
        var tmp0_safe_receiver = this.safeAreaPadding_1;
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = p.plus_dihzqn_k$(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs_0 = tmp_1;
        return tmp1_elvis_lhs_0 == null ? p : tmp1_elvis_lhs_0;
      }
      set_themeBase_daz04n_k$(value) {
        this.themeBase_1 = value;
        this.refreshTheming_1agefv_k$();
      }
      set_themeChoice_py59um_k$(value) {
        this.themePipeline_1.set_tnq7ny_k$(Companion_getInstance_3().themeChoice_1, value);
        this.refreshTheming_1agefv_k$();
      }
      get_themeChoice_22tyn3_k$() {
        return this.themePipeline_1.get_b304b5_k$(Companion_getInstance_3().themeChoice_1, this.get_outermostElement_wqahza_k$());
      }
      refreshTheming_1agefv_k$() {
        // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
        var tmp;
        if (!true && get_debugMode()) {
          tmp = true;
        } else {
          var tmp0_safe_receiver = Debugger_getInstance().debugTarget_1;
          tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_underlyingNativeElement_vngz33_k$()) === this;
        }
        if (tmp) {
          var tmp_0 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
          var tmp$ret$1 = 'refreshTheming';
          tmp_0.info_59mt0k_k$([tmp$ret$1]);
        }
        if (!this.checkIsActive$default_xrqsgk_k$('refreshTheming'))
          return Unit_instance;
        var tmp0_safe_receiver_0 = this.get_parent_hy4reb_k$();
        var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.get_underlyingNativeElement_vngz33_k$();
        if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.currentlyActive_eqs9ec_k$()) === false) {
          // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
          var tmp_1;
          if (!true && get_debugMode()) {
            tmp_1 = true;
          } else {
            var tmp0_safe_receiver_1 = Debugger_getInstance().debugTarget_1;
            tmp_1 = (tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.get_underlyingNativeElement_vngz33_k$()) === this;
          }
          if (tmp_1) {
            var tmp_2 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
            var tmp$ret$3 = 'abandoning refreshTheming because parent ' + toString_0(this.get_parent_hy4reb_k$()) + ' not started';
            tmp_2.info_59mt0k_k$([tmp$ret$3]);
          }
          return Unit_instance;
        }
        var base = this.themeBase_1.get_31089n_k$(asNativeElementOrFail(this));
        // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
        var tmp_3;
        if (!true && get_debugMode()) {
          tmp_3 = true;
        } else {
          var tmp0_safe_receiver_2 = Debugger_getInstance().debugTarget_1;
          tmp_3 = (tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.get_underlyingNativeElement_vngz33_k$()) === this;
        }
        if (tmp_3) {
          var tmp_4 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
          var tmp0_subject = this.themeBase_1;
          var source = equals(tmp0_subject, Companion_getInstance_2().fromParent_1) ? '' : equals(tmp0_subject, Companion_getInstance_2().fromParentNonCascading_1) ? 'Pulling non-cascading theme from parent.' : 'Pulling base theme from non-standard method.';
          var tmp$ret$5 = 'refreshTheming will set! ' + source + ' Base theme is ' + base.id_1;
          tmp_4.info_59mt0k_k$([tmp$ret$5]);
        }
        var t = this.themePipeline_1.apply_k7mlwn_k$(this.get_outermostElement_wqahza_k$(), base);
        // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
        var tmp_5;
        if (!true && get_debugMode()) {
          tmp_5 = true;
        } else {
          var tmp0_safe_receiver_3 = Debugger_getInstance().debugTarget_1;
          tmp_5 = (tmp0_safe_receiver_3 == null ? null : tmp0_safe_receiver_3.get_underlyingNativeElement_vngz33_k$()) === this;
        }
        if (tmp_5) {
          var tmp_6 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
          var tmp$ret$7 = 'refreshTheming will set to ' + t.theme_1.id_1 + '!';
          tmp_6.info_59mt0k_k$([tmp$ret$7]);
        }
        this.set_themeAndBack_a1wxbo_k$(t);
      }
      watchBackgroundProcess_1utgjt_k$(status) {
        // Inline function 'kotlin.also' call
        var this_0 = this.internalBackgroundProcesses_1.watch_lu5yhm_k$(status);
        onRemove(this, this_0);
        return this_0;
      }
      watchForegroundProcess_2u2sac_k$(status) {
        // Inline function 'kotlin.also' call
        var this_0 = this.internalForegroundProcesses_1.watch_lu5yhm_k$(status);
        onRemove(this, this_0);
        return this_0;
      }
      get_backgroundProcesses_v8cmfu_k$() {
        return this.internalBackgroundProcesses_1;
      }
      get_foregroundProcesses_2lrnkf_k$() {
        return this.internalForegroundProcesses_1;
      }
      set_accessibleLabel_97wje2_k$(_set____db54di) {
        this.accessibleLabel_1 = _set____db54di;
      }
      get_accessibleLabel_uztlo5_k$() {
        return this.accessibleLabel_1;
      }
      set_accessibleLiveRegion_kq920e_k$(_set____db54di) {
        this.accessibleLiveRegion_1 = _set____db54di;
      }
      set_labelFor_go6ca6_k$(_set____db54di) {
        this.labelFor_1 = _set____db54di;
      }
      get_labelFor_6to4xq_k$() {
        return this.labelFor_1;
      }
      set_describedBy_4bf3cf_k$(_set____db54di) {
        this.describedBy_1 = _set____db54di;
      }
      set_debugName_wihv62_k$(_set____db54di) {
        this.debugName_1 = _set____db54di;
      }
      get_debugName_58dolx_k$() {
        return this.debugName_1;
      }
      toString() {
        var tmp0_elvis_lhs = this.get_outermostElement_wqahza_k$().get_debugName_58dolx_k$();
        return tmp0_elvis_lhs == null ? get_theme(this).id_1 + toString_1(_Char___init__impl__6a9atx(32)) + removePrefix(toString(getKClassFromExpression(this.get_outermostElement_wqahza_k$())), 'class ') + '&' + toString_2(identityHashCode(this.get_outermostElement_wqahza_k$()), 16) : tmp0_elvis_lhs;
      }
      leakDetect_rzp4wm_k$() {
        checkLeakAfterDelay(new (WeakReference())(this), 1000n);
      }
      currentlyActive_eqs9ec_k$() {
        return this.fullyStarted_1 && !this.isShutdown_1;
      }
      checkIsShutdown_q5o5gy_k$(name) {
        if (this.isShutdown_1) {
          Default_getInstance().tag_ioihsw_k$('NativeElement').warn_e3mr9o_k$([name + ' called on shut-down element ' + viewPath(this)]);
          return true;
        }
        return false;
      }
      checkIsActive_qxqu03_k$(name, requireTarget) {
        if (this.checkIsShutdown_q5o5gy_k$(name))
          return false;
        if (!this.fullyStarted_1) {
          // Inline function 'com.lightningkite.kiteui.views.NativeElementCommonCode.debug' call
          var tmp;
          if (!requireTarget && get_debugMode()) {
            tmp = true;
          } else {
            var tmp0_safe_receiver = Debugger_getInstance().debugTarget_1;
            tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_underlyingNativeElement_vngz33_k$()) === this;
          }
          if (tmp) {
            var tmp_0 = Default_getInstance().tag_ioihsw_k$(this.toString() + ' DEBUG');
            var tmp$ret$1 = name + ' abandoned due to not fully started';
            tmp_0.info_59mt0k_k$([tmp$ret$1]);
          }
          return false;
        }
        return true;
      }
      checkIsActive$default_xrqsgk_k$(name, requireTarget, $super) {
        requireTarget = requireTarget === VOID ? true : requireTarget;
        return $super === VOID ? this.checkIsActive_qxqu03_k$(name, requireTarget) : $super.checkIsActive_qxqu03_k$.call(this, name, requireTarget);
      }
    }
    protoOf($).get_driverValue_yh5neo_k$ = get_driverValue;
    protoOf($).get_driverActions_8jqr2k_k$ = get_driverActions;
    protoOf($).driverDisplay_abwxi1_k$ = driverDisplay;
    protoOf($).invoke_s9332g_k$ = invoke;
    protoOf($).invoke_bnq13k_k$ = invoke_0;
    protoOf($).bind_gesskf_k$ = bind;
    protoOf($).debounce_nclnee_k$ = debounce;
    protoOf($).debounce_kh28nr_k$ = debounce_0;
    initMetadataForClass($, 'NativeElementCommonCode', VOID, VOID, [Element_0()]);
    NativeElementCommonCodeClass = $;
  }
  return NativeElementCommonCodeClass;
}
function asNativeElementOrFail(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof NativeElement() ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = _this__u8e3s4.toString() + ' is a NativeElementCommonCode but not a NativeElement \u2014 this violates the invariant that NativeElement is the only subclass of NativeElementCommonCode';
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
//region block: exports
export {
  ThemeForElement as ThemeForElement22lj47hlivf8f,
  NativeElementCommonCode as NativeElementCommonCode2d0djdz0fnra3,
  ensureOutermostElement as ensureOutermostElement1f4fzdv7yw0ql,
  _Step___init__impl__1kywol as _Step___init__impl__1kywol116oveu812gz,
  Companion_getInstance_2 as Companion_getInstanceztgx4sy4wjnt,
  Companion_getInstance_3 as Companion_getInstance22jtx90tar19r,
};
//endregion

//# sourceMappingURL=NativeElement.mjs.map
